export const jobCountLabel = (count: number): string =>
  `${count} ${count === 1 ? 'job' : 'jobs'}`

export const visitsLabel = (visitsCount: number): string =>
  `${visitsCount} ${visitsCount === 1 ? 'Visit' : 'Visits'}`
